import { Directive, TemplateRef, Input } from '@angular/core';
import { DataType } from '../../enums/shared/enums';

@Directive({
  selector: '[wtfTemplateLoader]'
})
export class TemplateLoaderDirective {
  @Input() type: DataType;

  constructor(public template: TemplateRef<any>) { }

}
